import {makeCreator} from '~/misc/dispatch';
import types from './types';

export const modalClose = makeCreator(types.MODAL_URI_CLOSED, (uri, context) => ({uri, context}));

export const modalCloseVerify = makeCreator(types.MODAL_URI_VERIFY_CLOSED);

export const modalChange = makeCreator(types.MODAL_URI_CHANGED,
  (uri, context) => {
    if (uri) {
      return {uri, context};
    }
    throw new Error('uri should be provided');
  }
);

export const videoChange = makeCreator(types.VIDEO_CHANGED, (vid, show) => ({vid, show}));



// WEBPACK FOOTER //
// ./src/modules/modal/actions.js